import IconCloseWindow from '@bimser/icons/16/close-window';
import React from 'react';
import { BCLoading } from '../../index';
import Styles from '../assets/reportContainerStyles.scss';
import { IReportDesignerProps } from '../entities';

export default function ReportDesigner(props: IReportDesignerProps) {
	const ref = React.useRef<HTMLDivElement>();
	const callbacks = React.useRef<any>();
	const designerModel = React.useRef<any>();

	const [loading, setLoading] = React.useState(true);

	React.useEffect(() => {
		let designer: any;
		import(/* webpackChunkName: "knockout" */ 'knockout').then(ko => {
			const reportUrl = ko.observable(
				`reportId=${props.reportId}&projectName=${props.projectName}&reportName=${props.reportName}`
			);
			const requestOptions = {
				host: `${(window as any).serviceConfig.urls.webInterface}/api/ide`,
				getDesignerModelAction: '/Report/GetDesignerModel'
			};

			import(
				/* webpackChunkName: "devexpress-analytics-core" */ '@devexpress/analytics-core/analytics-utils'
			).then(analyticsUtils => {
				import(
					/* webpackChunkName: "devexpress-reporting" */ 'devexpress-reporting/dx-reportdesigner'
				).then(dxReportDesigner => {
					import(
						/* webpackChunkName: "devexpress-reporting-tr-messages" */ 'devextreme/localization/messages/tr.json'
					).then(trMessages => {
						const designerModelObservable = ko.observable();
						callbacks.current = {
							CustomizeMenuActions: function (sender, args) {
								args.Actions.forEach(action => {
									if (
										[
											'dxrd-exit',
											'dxrd-newreport',
											'dxrd-open-report',
											'dxrd-save-as',
											'dxrd-exit'
										].includes(action.id)
									) {
										action.visible = false;
									}
									if (action.id === 'dxrd-newreport') {
										action.clickAction = function () {
											(sender as any).OpenReport(
												encodeURIComponent(reportUrl + '&newReport=true')
											);
										};
									}
								});
							},
							CustomizeLocalization: function (_, args) {
								const fileName = 'dx-analytics-core.tr.json';
								import('../data/' + fileName).then(trCore => {
									args.LoadMessages(trCore.default);
								});
							}
						};

						analyticsUtils.ajaxSetup.ajaxSettings = {
							headers: props.ajaxHeaders,
							async: false
						};

						designerModel.current = designerModelObservable;

						designer = new dxReportDesigner.DxReportDesigner(ref.current, {
							reportUrl,
							requestOptions,
							callbacks: callbacks.current,
							designerModel: designerModel.current
						});

						setLoading(false);
						designer.render();
					});
				});
			});
		});

		return () => {
			try {
				designer.dispose();
			} catch {
				console.log('An error occured while trying to dispose DxReportDesigner');
			}
		};
	}, []);

	function getPanelHeader() {
		return (
			<div className={Styles.WorkflowMenuHeader}>
				<div className={Styles.WorkflowMenuTitle}>{'Report Designer'}</div>
				<div className={Styles.WorkFlowMenuEvents}>
					<div className={Styles.Actions}>
						<div className={Styles.ButtonClose}>
							<IconCloseWindow onClick={props.exitDesigner} />
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className={Styles.reportDesignerContent}>
			{getPanelHeader()}
			<div
				ref={ref}
				className={Styles.reportDesigner}
			>
				<BCLoading
					show={loading}
					overlayClassName={Styles.loading}
				/>
			</div>
		</div>
	);
}
